import RadioGroupContainer from '@/components/RadioGroupContainer/RadioGroupContainer';
import { Column, Row } from '@/components/SettingsLayout';
import { Text, CheckBox } from '@/ui';
import RadioInput from '@/ui/RadioInput/RadioInput';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';
import { formatTestId } from '@/utils/helpers/formatTestId';

type Props = {
  extensions: Array<{
    _id: string;
    label: string;
    category: string;
  }>;
};

function ExtensionsRestrictions({ extensions }: Props) {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <Column gapSize='24' fullWidth>
      <Text size='l' weight='medium'>
        {t('Navigation.integrations')}
      </Text>
      <Column gapSize='16' fullWidth>
        <Controller
          name='extensions'
          control={control}
          render={({ field: { value, onChange } }) => (
            <>
              <RadioGroupContainer fullWidth>
                <Row fullWidth justify='justify-between'>
                  <Column gapSize='4'>
                    <RadioInput
                      id='unlimited'
                      checked={value === null}
                      onChange={() => onChange(null)}
                      label={t('Restrictions.unlimited')}
                      testId={formatTestId('extensions-restrictions-radio-button', 'unlimited')}
                    />
                  </Column>
                </Row>
                <Row fullWidth justify='justify-between'>
                  <Column gapSize='4'>
                    <RadioInput
                      id='limited'
                      checked={Array.isArray(value)}
                      onChange={() => onChange([])}
                      label={t('Restrictions.limited')}
                      testId={formatTestId('extensions-restrictions-radio-button', 'limited')}
                    />
                    <div className={styles.restrictionComment}>
                      <Text size='xs' weight='light-medium' color='base-grey'>
                        {t('Restrictions.integrations_select_comment')}
                      </Text>
                    </div>
                  </Column>
                </Row>
              </RadioGroupContainer>

              {Array.isArray(value) && (
                <div className={styles.integrationsContainer}>
                  <Column gapSize='16'>
                    {extensions.map((extension) => {
                      const isSelected = value.includes(extension._id);
                      return (
                        <CheckBox
                          key={extension._id}
                          isChecked={isSelected}
                          onChange={() => {
                            if (isSelected) {
                              onChange(value.filter((id: string) => id !== extension._id));
                            } else {
                              onChange([...value, extension._id]);
                            }
                          }}
                          id={extension._id}
                          label={t(`Extensions.${extension.label}`)}
                          comment={t(`Restrictions.${extension.label}_comment`)}
                        />
                      );
                    })}
                  </Column>
                </div>
              )}
            </>
          )}
        />
      </Column>
    </Column>
  );
}

export default ExtensionsRestrictions;
